export default "__VITE_ASSET__DMRWzqSR__"